import { OnboardingRequirement, ProfileInput, EmploymentStatus } from 'generated/types'
import { Flow, FlowRoute } from 'utils/FlowProvider/types'

import { ANSWER_SESSION_KEY } from './SuitabilityQuestion'

export type PathMetadata = {
  [key in FlowRoute]?: {
    stringPrefix: string
    eventType: string
    requirement: OnboardingRequirement
    key: keyof ProfileInput
  }
}

const investPathToMetadata: PathMetadata = {
  [FlowRoute.EmploymentStatus]: {
    stringPrefix: 'employment_status',
    eventType: 'employment',
    requirement: OnboardingRequirement.EMPLOYMENT_STATUS,
    key: 'employmentStatus',
  },
  [FlowRoute.InvestmentGoal]: {
    stringPrefix: 'investment_goal',
    eventType: 'investment_goal',
    requirement: OnboardingRequirement.INVESTMENT_GOAL,
    key: 'investmentGoal',
  },
  [FlowRoute.FinancialEducation]: {
    stringPrefix: 'financial_education',
    eventType: 'financial_education',
    requirement: OnboardingRequirement.FINANCIAL_EDUCATION,
    key: 'financialEducation',
  },
  [FlowRoute.NetWorth]: {
    stringPrefix: 'net_worth',
    eventType: 'net_worth',
    requirement: OnboardingRequirement.NET_WORTH,
    key: 'netWorth',
  },
  [FlowRoute.AnnualIncome]: {
    stringPrefix: 'annual_income',
    eventType: 'yearly_income',
    requirement: OnboardingRequirement.ANNUAL_INCOME,
    key: 'annualIncome',
  },
}

const laterPathToMetadata: PathMetadata = {
  [FlowRoute.EmploymentStatus]: {
    stringPrefix: 'employment_status',
    eventType: 'employment_status',
    requirement: OnboardingRequirement.EMPLOYMENT_STATUS,
    key: 'employmentStatus',
  },
  [FlowRoute.MaritalStatus]: {
    stringPrefix: 'marital_status',
    eventType: 'marital_status',
    requirement: OnboardingRequirement.MARITAL_STATUS,
    key: 'maritalStatus',
  },
  [FlowRoute.TaxFilingType]: {
    stringPrefix: 'filing_type',
    eventType: 'filing_type',
    requirement: OnboardingRequirement.FILING_TYPE,
    key: 'filingType',
  },
  [FlowRoute.AnnualIncome]: {
    stringPrefix: 'annual_income',
    eventType: 'annual_income',
    requirement: OnboardingRequirement.ANNUAL_INCOME,
    key: 'annualIncome',
  },
  [FlowRoute.CombinedAnnualIncome]: {
    stringPrefix: 'combined_annual_income',
    eventType: 'combined_annual_income',
    requirement: OnboardingRequirement.COMBINED_ANNUAL_INCOME,
    key: 'combinedAnnualIncome',
  },
  [FlowRoute.SelfEmployedIncome]: {
    stringPrefix: 'self_employed_income',
    eventType: 'self_employed_income',
    requirement: OnboardingRequirement.SELF_EMPLOYED_INCOME,
    key: 'selfEmployedIncome',
  },
  [FlowRoute.Employees]: {
    stringPrefix: 'employees',
    eventType: 'employees',
    requirement: OnboardingRequirement.EMPLOYEES,
    key: 'employees',
  },
}

const flowToMetadata: { [key in Flow]?: PathMetadata } = {
  investOnboarding: investPathToMetadata,
  laterOnboarding: laterPathToMetadata,
}

export const getPathToMetadata = (flow: Flow): PathMetadata => {
  const metadata = flowToMetadata[flow]

  if (flow === 'laterOnboarding') {
    const allSuitabilityAnswers = JSON.parse(window.sessionStorage.getItem(ANSWER_SESSION_KEY))
    const answer = allSuitabilityAnswers?.[metadata[FlowRoute.EmploymentStatus].key]
    if (answer === EmploymentStatus.selfEmployed) {
      const metadataCopy = JSON.parse(JSON.stringify(metadata))
      metadataCopy[FlowRoute.AnnualIncome].stringPrefix = 'annual_income_with_self_employed'
      metadataCopy[FlowRoute.CombinedAnnualIncome].stringPrefix =
        'combined_annual_income_with_self_employed'
      return metadataCopy
    }
  }

  return metadata
}
